import { NLPSearchJSONResultFormat } from '../types';
import { getTypedJSONResultData } from './getTypedJSONResultData';
export var getKnowledgeCardResultCount = function getKnowledgeCardResultCount(_ref) {
  var answerString = _ref.answerString;
  if (!answerString) {
    return 0;
  }
  var _getTypedJSONResultDa = getTypedJSONResultData(answerString),
    parsedResult = _getTypedJSONResultDa.parsedResult,
    parsedType = _getTypedJSONResultDa.parsedType;
  switch (parsedType) {
    case NLPSearchJSONResultFormat.TEAM:
      return 'id' in parsedResult && parsedResult.id ? 1 : 0;
    case NLPSearchJSONResultFormat.WHO:
    case NLPSearchJSONResultFormat.PERSON:
    case NLPSearchJSONResultFormat.WORK:
      return Array.isArray(parsedResult) ? parsedResult.length : 0;
    default:
      return 0;
  }
};